import api from './api'

class TimeTrackerService {
    // 获取baseTodo列表
    static async getBaseTodos() {
        const response = await api.get('/usertodo/get_base_todos/')
        return response.data
    }

    // 获取baseTodo（根据bind_todo_id）
    static async getBaseTodoByBindTodo(bindTodoId) {
        const response = await api.post('/usertodo/get_base_todo_by_bind_todo/', { bind_todo_id: bindTodoId })
        return response.data
    }

    // 创建新的baseTodo
    static async createBaseTodo(data) {
        const response = await api.post('/usertodo/create_base_todo/', data)
        return response.data
    }

    // 更新baseTodo
    static async updateBaseTodo(id, data) {
        const response = await api.post(`/usertodo/${id}/update_base_todo/`, data)
        return response.data
    }

    // 删除baseTodo
    static async deleteBaseTodo(id) {
        const response = await api.post(`/usertodo/${id}/delete_base_todo/`)
        return response.data
    }

    // 获取TodoItem列表
    static async getTodoItems() {
        const response = await api.get('/usertodo/get_todo_items/')
        return response.data
    }

    // 获取最新的todoHistory记录
    static async getLatestTodoHistory() {
        const response = await api.get('/usertodo/get_latest_todo_history/')
        return response.data
    }

    // 获取todoHistory列表
    static async getTodoHistoryList() {
        const response = await api.get('/usertodo/get_todo_history_list/')
        return response.data
    }

    // 获取指定日期范围的todoHistory列表
    static async getTodoHistoryListByDate(startDate, endDate) {
        const response = await api.post('/usertodo/get_todo_history_list_by_date/', {
            start_date: startDate,
            end_date: endDate
        })
        return response.data
    }

    // 按时间维度统计todoHistory
    static async getStatisticsByTime(startDate, endDate, dimension) {
        const response = await api.post('/usertodo/get_statistics_by_time/', {
            start_date: startDate,
            end_date: endDate,
            dimension: dimension
        })
        return response.data
    }

    // 按分类统计todoHistory
    static async getStatisticsByCategory(startDate, endDate) {
        const response = await api.post('/usertodo/get_statistics_by_category/', {
            start_date: startDate,
            end_date: endDate
        })
        return response.data
    }

    // 更新todoHistory的end_time
    static async updateTodoHistoryEndTime(id, endTime) {
        console.log('API CALL: updateTodoHistoryEndTime - Updating record ID:', id, 'with endTime:', endTime);
        const response = await api.post('/usertodo/update_todo_history_end_time/', {
            id: id,
            end_time: endTime
        })
        console.log('API RESPONSE: updateTodoHistoryEndTime - Received response:', response);
        return response.data
    }

    // 创建新的todoHistory
    static async createTodoHistory(data) {
        console.log('API CALL: createTodoHistory - Sending data:', data);
        const response = await api.post('/usertodo/create_todo_history/', data)
        console.log('API RESPONSE: createTodoHistory - Received response:', response);
        return response.data
    }

    // 更新todoHistory记录
    static async updateTodoHistory(id, data) {
        console.log('API CALL: updateTodoHistory - Updating record ID:', id, 'with data:', data);
        const response = await api.post(`/usertodo/${id}/update_todo_history/`, data)
        console.log('API RESPONSE: updateTodoHistory - Received response:', response);
        return response.data
    }

    // 获取TodoTypes列表
    static async getTodoTypes() {
        const response = await api.get('/usertodo/get_todo_types/')
        return response.data
    }

    // 获取任务每日时间统计数据（用于折线图）
    static async getTaskDailyStats(startDate, endDate) {
        const response = await api.post('/usertodo/get_task_daily_stats/', {
            start_date: startDate,
            end_date: endDate
        })
        return response.data
    }
}

export default TimeTrackerService